<ng-container *transloco="let t" class="container language-modal">
  <div class="modal-header d-flex align-items-center pt-4 pb-3 px-4">
    <div class="fw-semibold title-wrapper line-height-1 fs-18">
      {{t("page.header.change.language")}}
    </div>
    <button type="button" class="btn-close" aria-label="Close" (click)="onClose()">
    </button>
  </div>
  <div class="divider"></div>
  <div class="modal-body pb-4 px-4">
    <div class="row row-cols-2 row-cols-md-3 mt-2">
      <div class="col mb-3">
        <div class="language-item d-flex justify-content-between align-items-center" (click)="selectLang('hr')"
             [ngClass]="{ 'selected': selectedLang === 'hr' }">
          <div>
            <p>{{t("app.common.language.hr")}}</p>
            <p class="fw-300">(Hrvatski)</p>
          </div>
          @if (selectedLang === 'hr') {
            <div class="checkmark">
              <i class="bi bi-check-circle-fill"></i>
            </div>
          }
        </div>
      </div>

      <div class="col mb-3">
        <div class="language-item d-flex justify-content-between align-items-center" (click)="selectLang('en')"
             [ngClass]="{ 'selected': selectedLang === 'en' }">
          <div>
            <p>{{t("app.common.language.en")}}</p>
            <p class="fw-300">(English)</p>
          </div>
          @if (selectedLang === 'en') {
            <div class="checkmark d-flex">
              <i class="bi bi-check-circle-fill"></i>
            </div>
          }
        </div>
      </div>

      <div class="col mb-3">
        <div class="language-item d-flex justify-content-between align-items-center" (click)="selectLang('bs')"
             [ngClass]="{ 'selected': selectedLang === 'bs' }">
          <div>
            <p>{{t("app.common.language.bs")}}</p>
            <p class="fw-300">(Bosanski)</p>
          </div>
          @if (selectedLang === 'bs') {
            <div class="checkmark d-flex">
              <i class="bi bi-check-circle-fill"></i>
            </div>
          }
        </div>
      </div>

      <div class="col mb-3">
        <div class="language-item d-flex justify-content-between align-items-center" (click)="selectLang('de')"
             [ngClass]="{ 'selected': selectedLang === 'de' }">
          <div>
            <p>{{t("app.common.language.de")}}</p>
            <p class="fw-300">(Deutsch)</p>
          </div>
          @if (selectedLang === 'de') {
            <div class="checkmark d-flex">
              <i class="bi bi-check-circle-fill"></i>
            </div>
          }
        </div>
      </div>

      <div class="col mb-3">
        <div class="language-item d-flex justify-content-between align-items-center" (click)="selectLang('fr')"
             [ngClass]="{ 'selected': selectedLang === 'fr' }">
          <div>
            <p>{{t("app.common.language.fr")}}</p>
            <p class="fw-300">(Français)</p>
          </div>
          @if (selectedLang === 'fr') {
            <div class="checkmark d-flex">
              <i class="bi bi-check-circle-fill"></i>
            </div>
          }
        </div>
      </div>

      <div class="col mb-3">
        <div class="language-item d-flex justify-content-between align-items-center" (click)="selectLang('it')"
             [ngClass]="{ 'selected': selectedLang === 'it' }">
          <div>
            <p>{{t("app.common.language.it")}}</p>
            <p class="fw-300">(Italiano)</p>
          </div>
          @if (selectedLang === 'it') {
            <div class="checkmark d-flex">
              <i class="bi bi-check-circle-fill"></i>
            </div>
          }
        </div>
      </div>

      <div class="col">
        <div class="language-item d-flex justify-content-between align-items-center" (click)="selectLang('slo')"
             [ngClass]="{ 'selected': selectedLang === 'slo' }">
          <div>
            <p>{{t("app.common.language.slo")}}</p>
            <p class="fw-300">(Slovenščina)</p>
          </div>
          @if (selectedLang === 'slo') {
            <div class="checkmark d-flex">
              <i class="bi bi-check-circle-fill"></i>
            </div>
          }
        </div>
      </div>

      <div class="col">
        <div class="language-item d-flex justify-content-between align-items-center" (click)="selectLang('sr')"
             [ngClass]="{ 'selected': selectedLang === 'sr' }">
          <div>
            <p>{{t("app.common.language.sr")}}</p>
            <p class="fw-300">(Srpski)</p>
          </div>
          @if (selectedLang === 'sr') {
            <div class="checkmark d-flex">
              <i class="bi bi-check-circle-fill"></i>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="divider"></div>
  <div class="modal-footer">
    <div class="d-flex justify-content-end">
      <app-button-alt [buttonColor]="'transparent'" [textColor]="'var(--teal-500)'" [buttonHeight]="'44px'"
                      [text]="t('app.common.cancel') | uppercase" [borderColor]="'transparent'"
                      (onClickCallback)="onClose()" class="me-2"></app-button-alt>

      <app-button-alt [buttonColor]="'var(--teal-500)'" [textColor]="'white'" [buttonHeight]="'44px'"
                      [text]="t('app.common.save.changes') | uppercase" [borderColor]="'var(--teal-500)'"
                      (onClickCallback)="changeLang(selectedLang!)"></app-button-alt>
    </div>
  </div>
</ng-container>

